// extracted by mini-css-extract-plugin
module.exports = {"list":"list--vsnXh","item":"item--K0DAB","item__additional":"item__additional--S02DD"};